import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Conges } from '../model/conges';

@Injectable({
    providedIn: 'root'
  })
  export class CongesService{

    constructor(private _restClientService : RestClientService) 
    {}

    get(congeId){
        return this._restClientService.load<Conges>('conges/get/'+congeId);
    }
    
    deleteConge(id) 
    {
        return this._restClientService.delete<any>('conges/delete/'+id);
    }
  
    addConge(conge) {
        return  this._restClientService.save<Conges>('conges/add', conge);
    }
     
    updateConge(conge) {
        return  this._restClientService.put<Conges>(`conges/update`, conge);
    }
     
    getListCongesByAnneeAndCurrentUsername(annee){
        return this._restClientService.load<Conges[]>('conges/conges-by-annee-and-currentusername?annee='+annee);
    }
    
    getListCongesByAnneeAndUsername(username,annee){
        return this._restClientService.load<Conges[]>('conges/conges-by-annee-and-username?annee='+annee+'&username='+username);
    }
    
    assignerPortefeuilleAuBackUpByUsername(username){
        return this._restClientService.load<void>('conges/assigner-au-backup-by-username?username='+username);
    }
    
  }